const { vehicleService } = require("../services/vehicle-service");
const { constructResidualsRequest } = require("./construct-residuals-request");

async function getResiduals(vehicle, deposit = 0, proposals = null, terms = null, annualMileage = 8000, updatedMileage = null, keepExisting = false, doNotGetLenders = null, vehicleTypeId = null, capCode = null) {

    try {

        if(terms && Array.isArray(terms)){
            terms = terms.map(t => Number(t));
        }

        // get existing residual values from vehicle object
        const existing = vehicle.vehicleResiduals && ( updatedMileage ? updatedMileage === vehicle.mileage : true) ? 
            (typeof vehicle.vehicleResiduals === 'string' || vehicle.vehicleResiduals instanceof String) ? 
                JSON.parse(vehicle.vehicleResiduals) : 
                vehicle.vehicleResiduals : 
            null;

        // if we are keeping existing residuals, we need to check which lenders we already have residuals for
        const alreadyHasLenderResiduals = [];
        
        if(existing && keepExisting){
            // If keeping existing residuals, we need to check for missing terms
            Object.keys(existing).forEach((lenderId) => {
                const existingTerms = Object.keys(existing[lenderId]).map(t => Number(t));

                const notIncluded = terms.filter(t => !existingTerms.includes(t));

                // if no missing terms for lender, do not need to request
                if(notIncluded.length === 0){
                    console.log("Already has all terms for lender", lenderId);
                    alreadyHasLenderResiduals.push(Number(lenderId));
                }
            })
        }

        const request = await constructResidualsRequest(vehicle, deposit, proposals, terms, annualMileage, updatedMileage, vehicleTypeId, capCode);

        if(!request){
            return existing;
        }

        if(doNotGetLenders && Array.isArray(doNotGetLenders)){
            request.financeCompanyResidualSetting = request.financeCompanyResidualSetting.filter(f => !doNotGetLenders.includes(f.financeCompanyId));
        }

        if(keepExisting && alreadyHasLenderResiduals.length > 0){
            request.financeCompanyResidualSetting = request.financeCompanyResidualSetting.filter(f => !alreadyHasLenderResiduals.includes(f.financeCompanyId));
        }
    
        if(request.financeCompanyResidualSetting.length === 0){
            if(keepExisting){
                console.log("Already has all residuals for proposals");
            }
            return keepExisting ? existing : null;
        }

        const response = await vehicleService.getResiduals(request);

        if(!response){
            return existing;
        }

        if(!keepExisting || !existing){
            const rvs = {};
            response.forEach(r => {
              const rs = {};
              r.residualValues.forEach(v => {
                if(!v.hasErrored){
                    rs[v.term] = v.value;
                }
              })  
              rvs[r.financeCompanyId] = rs;
            });
            return rvs;
        }

        // Add missing terms from existing lender
        Object.keys(existing).forEach((lenderId) => {
            const nr = Object.keys(response).find(r => r.financeCompanyId === lenderId);
            if(nr){
                existing[lenderId] = { ...response.find(f => f.financeCompanyId === lenderId).residualValues.map(rv => [rv.term][rv.value]), ...existing[lenderId] };
            }
        })

        // add missing requested lenders from existing residuals
        response.forEach((lender) => {
            const lenderId = lender.financeCompanyId;
            if(!existing[lenderId]){
                const values = {};
                lender.residualValues.forEach(v => {
                    values[v.term] = v.value;
                })  
                existing[lenderId] = values;
            }
        })

        return existing;
    }
    catch (error) {
        console.log("Pricing Library Error - getResiduals", error);
        return null;
    }
}

module.exports = {
    getResiduals
}